import { render } from "./fullscreen-product-gallery.vue?vue&type=template&id=42a7b6fc"
import script from "./fullscreen-product-gallery.vue?vue&type=script&lang=js"
export * from "./fullscreen-product-gallery.vue?vue&type=script&lang=js"

import "./fullscreen-product-gallery.vue?vue&type=style&index=0&id=42a7b6fc&lang=scss"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__